import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ProductCodeStore, ProductCodeState } from './product-code.store';
import { MemberCardQuery } from '../../account/member-card/member-card.query';
import { map } from 'rxjs/operators';
import { MemberQuery } from '../../account/member/member.query';

@Injectable({ providedIn: 'root' })
export class ProductCodeQuery extends QueryEntity<ProductCodeState> {

  constructor(protected store: ProductCodeStore, 
              private memberCardQuery: MemberCardQuery, 
              private memberQuery: MemberQuery) {
    super(store);
  }

  selectCurrentUserIsProductCode(productCodes: string[]) {
    return this.memberCardQuery.selectObservedMemberCard().pipe(
      map((card) => {
        if (card) {
          return productCodes.map(code => code.toLowerCase().trim()).includes(card.ProductCode.toLowerCase().trim());
        } else {
          return false;
        }
      })
    );
  }

  selectCurrentUserIsNotProductCode(productCodes: string[]) {
    return this.memberCardQuery.selectObservedMemberCard().pipe(
      map((card) => {
        if (card) {
          return !productCodes.map(code => code.toLowerCase().trim()).includes(card.ProductCode.toLowerCase().trim());
        } else {
          return false;
        }
      })
    );
  }

  currentUserIsProductCode(productCodes: string[]) {
    const currentCode = this.memberCardQuery.getEntity(this.memberQuery.getUserContext().memberId)?.ProductCode;
    if (!currentCode) {
      return false;
    }
    return productCodes.map(code => code.toLowerCase().trim()).includes(currentCode.toLowerCase().trim());
  }
  
  currentUserIsNotProductCode(productCodes: string[]) {
    return !this.currentUserIsProductCode(productCodes);
  }
}
